var _polygon, _polygon2, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 70,
    viewBox: "0 0 260 70",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "15,35 30,10 60,10 75,35 60,60 30,60",
    fill: "#E74C3C",
    stroke: "none"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "30,35 37.5,22.5 52.5,22.5 60,35 52.5,47.5 37.5,47.5",
    fill: "#000",
    stroke: "none"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 35,
    fontFamily: "Montserrat, sans-serif",
    fontWeight: "bold",
    fontSize: 28,
    fill: "#000000"
  }, "PETEK")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 90,
    y: 60,
    fontFamily: "Montserrat, sans-serif",
    fontWeight: "bold",
    fontSize: 30,
    fill: "#000000",
    letterSpacing: 17
  }, "B2B")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a64ce086cef5be8010cf7783d6604a9b.svg";
export { ForwardRef as ReactComponent };